<template>
  <div id="Company__card__form">
    <a-divider v-if="searchCompanyNip">{{searchCompanyNip.TITLE}}</a-divider>
    <a-row type="flex" justify="space-around" align="middle">
      <a-col :span="16">
        <a-form-model :model="FormData" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item :label="$t('Full name')">
            <a-input v-model="FormData.TITLE" :placeholder="$t('Full name')"></a-input>
          </a-form-model-item>

          <template v-if="saveCompanyTypeNip.Fields">
            <a-form-model-item v-for="(value, key) in settingsNip" :key="key">
              <a-tooltip slot="label">
                <template slot="title">{{$t(key)}}</template>
                {{value.name}}
                <a-icon type="info-circle" />
              </a-tooltip>

              <a-input v-model="FormData[value.id]" :placeholder="$t(key)">
                <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
              </a-input>
            </a-form-model-item>
          </template>
          <template v-else>
            <a-form-model-item v-for="(value, key) in settingsNip" :key="key">
              <span slot="label">{{$t(key)}}</span>

              <a-input v-model="FormData[key]" :placeholder="$t(key)">
                <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
              </a-input>
            </a-form-model-item>
          </template>
        </a-form-model>
      </a-col>
      <a-col :span="7" :offset="1">
        <h4 style="text-align: center;">{{$t('Status')}} VAT</h4>
        <a-tag
          color="green"
          class="status_vat_tag"
          v-if="InfoOnNIP.VAT_STATUS == 'Active'"
        >{{$t('statusVAT_Active')}}</a-tag>
        <a-tag
          color="green"
          class="status_vat_tag"
          v-else-if="InfoOnNIP.VAT_STATUS == 'Freed'"
        >{{$t('statusVAT_Freed')}}</a-tag>
        <a-tag
          color="red"
          class="status_vat_tag"
          v-else-if="InfoOnNIP.VAT_STATUS == 'Not_active'"
        >{{$t('statusVAT_Not_active')}}</a-tag>
        <a-tag v-else class="status_vat_tag">{{$t('Not found NIP')}}</a-tag>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-between" align="middle">
      <a-col>
        <a-button @click="PrevStep">{{$t('Back')}}</a-button>
      </a-col>
      <a-col v-if="searchCompanyNip">
        <a-alert banner>
          <h4 slot="message">
            {{$t('A company with such a NIP already exists.')}}
            <a
              :href="`https://${Auth.domain}/crm/company/details/${searchCompanyNip.ID}/`"
              target="_blank"
              style="color: rgb(0, 143, 212);text-decoration: none;"
            >{{$t('View company')}}</a>
          </h4>
        </a-alert>
      </a-col>
      <a-col>
        <a-button
          v-if="searchCompanyNip"
          @click="UpdateCompany"
          style="margin-left: 25px"
        >{{$t('Update company')}}</a-button>
        <a-button
          type="primary"
          style="margin-left: 25px"
          @click="CreateCompany"
        >{{$t('Create company')}}</a-button>
      </a-col>
    </a-row>
    <br />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
    };
  },
  computed: mapGetters([
    "searchCompanyNip",
    "InfoOnNIP",
    "settingsNip",
    "FormData",
    "saveCompanyTypeNip",
    "Auth",
  ]),
  mounted() {
    this.resizeWindow();
  },
  updated() {
    this.resizeWindow();
  },
  methods: {
    ...mapActions([
      "NextStep",
      "PrevStep",
      "UpdateCompany",
      "CreateCompany",
      "resizeWindow",
    ]),
  },
};
</script>

<style scoped>
.col_text {
  text-align: center;
}
.status_vat_tag {
  text-align: center;
  white-space: normal;
  font-size: 16px;
  margin-right: 0;
  height: 300px;
  padding: 40% 10%;
  width: 100%;
}
</style>
